import React, { useEffect, useRef, useState } from "react";
import useAxios, { UseAxiosProps } from "./useAxios";
import IDeck from "../../api/IDeck";
import { useUserStore } from "../../stores/useUserStore";

type UseAllDecksProps = {
    axiosProps?: UseAxiosProps;
};

const useAllDecks = (props?: UseAllDecksProps) => {
    const user = useUserStore((state) => state.user);
    const [decks, setDecks] = useState<IDeck[]>([]);
    const { loading, error, setError, clearError, get } = useAxios(
        props?.axiosProps
    );
    
    // ✅ 新增：isMounted 检查防止内存泄漏
    const isMountedRef = useRef(true);
    
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (user.refreshToken.length > 0) getAllDecks();
    }, [user.refreshToken]);

    const getAllDecks = async () => {
        let res = await get<IDeck[]>(`/api/deck/GetPokerDecks`);
        // ✅ 仅在组件仍然挂载时才更新状态
        if (res && isMountedRef.current) setDecks(res);
    };

    return {
        loading,
        error,
        decks,

        setError,
        clearError,
    };
};

export default useAllDecks;
